var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"inventory"}},_vm._l((_vm.items),function(i,idx){return _c('div',{key:idx},[_c('div',{staticClass:"item",class:{ active: i[1].inMantu },on:{"click":function($event){return _vm.moveItem(i)}}},[_vm._v(" "+_vm._s(i[1].text)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }